export default __webpack_public_path__ + "static/media/Billing.e31190cf.svg";